/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type User = {
    id?: string;
    /**
     * Steam ID of the user
     */
    steamId?: string;
    /**
     * Display name from Steam
     */
    name?: string;
    /**
     * Avatar URL from Steam
     */
    avatar?: string;
    /**
     * Steam profile URL
     */
    profileUrl?: string;
    /**
     * Steam trade URL
     */
    tradeUrl?: string;
    /**
     * Steam level
     */
    steamLevel?: number;
    /**
     * User balance in cents
     */
    balance?: number;
    /**
     * Number of case tokens
     */
    caseToken?: number;
    /**
     * Total XP earned from case openings
     */
    levelXp?: number;
    /**
     * Current level calculated from XP
     */
    currentLevel?: number;
    /**
     * XP required to reach current level (starting point)
     */
    currentLevelXp?: number;
    /**
     * Total XP needed to reach next level
     */
    nextLevelXp?: number;
    /**
     * User status: 0=Active, 1=Banned, 2=Locked
     */
    status?: User.status;
    /**
     * Indicates whether the user currently has VIP status
     */
    isVip?: boolean;
    /**
     * Referral code used during registration
     */
    usedReferralCode?: string;
    /**
     * Current referral tier level for the user
     */
    referralLevel?: number | null;
    /**
     * Available whale points for current promotional event
     */
    whalePoints?: number | null;
    /**
     * 2-letter country code from Cloudflare (e.g., "US", "TR")
     */
    countryCode?: string | null;
    createdAt?: string;
    updatedAt?: string;
};
export namespace User {
    /**
     * User status: 0=Active, 1=Banned, 2=Locked
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
    }
}

